import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { UserInfo } from "./utils/jwtUtils";

export const userInfoAtom = atom<UserInfo | null>(null);

export const isPasscodeAuthenticatedAtom = atom<boolean>(false);

// Persisted atoms using atomWithStorage for automatic localStorage sync
export const setupCompleteAtom = atomWithStorage<boolean>("setupComplete", false);

export const hideTiktokBannerAtom = atomWithStorage<boolean>("hideTiktokBanner", false);

export const isTiktokLinkedAtom = atomWithStorage<boolean>("isTiktokLinked", false);
